import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex);

const store = new Vuex.Store({  // 创建一个store
    state:{
        collapse:false
    },
    actions:{
        actionChange(ctx,collapse){
            ctx.commit("mutatiosChange",collapse);
        }
    },
    mutations:{
        mutatiosChange(state,collapse){
            state.collapse = collapse;
        }
    }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js